import React, { useState, useEffect, ChangeEvent, FormEvent } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Button,
  NumberInput,
  NumberInputField,
  SimpleGrid,
  useToast,
  Select,
} from '@chakra-ui/react';
import axios from 'axios';
interface Localidad {
  id: number;
  idMunicipio: number;
  descripcion: string;
  habilitado: boolean;
  idLocalidad: number;
}

interface TipoPredio {
  id: string;
  descripcion: string;
  habilitado: boolean;
}
interface Predio {
  idClaveCatastral: string;
  ClaveCatastral: {
    claveCatastralEstandar: string;
    idLocalidad: string;
    idTipoPredio: string;
  };
  idUsoDestino: number;
  idTenencia: number;
  idRegimenPropiedad: number;
  idTipoPosesion: number;
  idEstadoFisico: number;
  idServicioInspeccion?: number;
  calle: string;
  numeroExterior: string;
  numeroInterior?: string;
  letra?: string;
  colonia: string;
  poblacion: string;
  paraje?: string;
  denominacion?: string;
  nivelesConstruidos: number;
  nivelesSubterraneos: number;
  fechaAlta: string;
  observaciones?: string;
  DomicilioDeNotificacion?: string;
  codigoPostal: number;
  ciudad: string;
  indiviso: number;
  frente: number;
  fondo: number;
  edificio: number;
  nivel: number;
  areaConsPrivativa: number;
  areaConsComun: number;
  areaConsTotal: number;
  areaTerrPrivativa: number;
  areaTerrComun: number;
  areaTerrTotal: number;
  areaTerrCarto: number;
  fechaActualizacion: string;
  usuario: string;
  origenMovimiento?: string;
  cuentaOrigen?: string;
  fechaOperacion?: string;
}

interface PredioFormProps {
  id?: string; // Para identificar si es edición o creación
}

const PredioForm: React.FC<PredioFormProps> = ({ id }) => {
  const [localidades, setLocalidades] = useState<Localidad[]>([]);
  const [tipopredio, setTipoPredio] = useState<TipoPredio[]>([]);

  const [predio, setPredio] = useState<Predio>({
    idClaveCatastral: '',
    ClaveCatastral: {
      claveCatastralEstandar: '',
      idLocalidad: '',
      idTipoPredio: '',
    },
    idUsoDestino: 0,
    idTenencia: 0,
    idRegimenPropiedad: 0,
    idTipoPosesion: 0,
    idEstadoFisico: 0,
    calle: '',
    numeroExterior: '',
    numeroInterior: '',
    letra: '',
    colonia: '',
    poblacion: '',
    paraje: '',
    denominacion: '',
    nivelesConstruidos: 0,
    nivelesSubterraneos: 0,
    fechaAlta: new Date().toISOString(),
    observaciones: '',
    codigoPostal: 0,
    ciudad: '',
    indiviso: 0,
    frente: 0,
    fondo: 0,
    edificio: 0,
    nivel: 0,
    areaConsPrivativa: 0,
    areaConsComun: 0,
    areaConsTotal: 0,
    areaTerrPrivativa: 0,
    areaTerrComun: 0,
    areaTerrTotal: 0,
    areaTerrCarto: 0,
    fechaActualizacion: new Date().toISOString(),
    usuario: '',
    origenMovimiento: '',
    cuentaOrigen: '',
    fechaOperacion: '',
  });
  const handleSelectChange = (name: string, value: string | number) => {
    setPredio((prev) => ({
      ...prev,
      ClaveCatastral: { ...prev.ClaveCatastral, [name]: value },
    }));
  };

  const toast = useToast();

  useEffect(() => {
    if (id) {
      axios
        .get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/predio/${id}`)
        .then((response) => setPredio(response.data))
        .catch(() => {
          toast({
            title: 'Error',
            description: 'No se pudo cargar la información del predio.',
            status: 'error',
            duration: 5000,
            isClosable: true,
          });
        });
    }

    // Cargar localidades
    axios
      .get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cLocalidadRoutes`)
      .then((response) => setLocalidades(response.data))
      .catch(() => {
        toast({
          title: 'Error',
          description: 'No se pudo cargar la lista de localidades.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      });

    axios
      .get(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cTipoPredioRoutes`)
      .then((response) => setTipoPredio(response.data))
      .catch(() => {
        toast({
          title: 'Error',
          description: 'No se pudo cargar la lista de localidades.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      });
  }, [id, toast]);

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setPredio((prev) => ({ ...prev, [name]: value }));
    // setPredio((prev) => ({
    //   ...prev,
    //   ClaveCatastral: { ...prev.ClaveCatastral, [name]: value },
    // }));
  };

  const handleChangex = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    //setPredio((prev) => ({ ...prev, [name]: value }));
    setPredio((prev) => ({
      ...prev,
      ClaveCatastral: { ...prev.ClaveCatastral, [name]: value },
    }));
  };
  const handleNumberChange = (name: string, value: number) => {
    setPredio((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      if (id) {
        await axios.put(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/predio/${id}`, predio);
        toast({
          title: 'Éxito',
          description: 'El predio ha sido actualizado correctamente.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
      } else {
        

        const res = await axios.post(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/predio`, predio);
      
        // const payload = {
        //   ...predio,
        //   ClaveCatastral: {
        //     ...predio.ClaveCatastral,
        //     idLocalidad: predio.ClaveCatastral.idLocalidad || '', // Verifica que idLocalidad esté definido
        //   },
        // };
        if(res.data==''){
          toast({
            title: 'Error',
            description: '💀💀💀 No se pudo generar el predio con clave: '+predio.ClaveCatastral.claveCatastralEstandar,
            status: 'error',
            duration: 5000,
            isClosable: true,
          });
        }else{
        toast({
          title: 'Éxito',
          description: 'El predio ha sido creado correctamente.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
      }
      }
    } catch {
      toast({
        title: 'Error',
        description: 'No se pudo guardar la información del predio.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Box p={[2, 4, 6]} maxW="1200px" mx="auto">
      <form onSubmit={handleSubmit}>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
          {' '}
          <FormControl>
            <FormLabel >
              Clave Catastral
            </FormLabel>
            <Input
              name="claveCatastralEstandar"
              value={predio.ClaveCatastral.claveCatastralEstandar}
              onChange={handleChangex}
              placeholder="Clave Catastral"
              isRequired
            />
          </FormControl>
          <FormControl>
            <FormLabel>Tipo de Predio</FormLabel>

            <Select
              name="idTipoPredio"
              value={predio.ClaveCatastral.idTipoPredio}
              onChange={(e) =>
                handleSelectChange('idTipoPredio', e.target.value)
              }
              placeholder="Seleccione un Tipo de Predio"
              isRequired
            >
              {tipopredio.map((localidad) => (
                <option key={localidad.id} value={localidad.id}>
                  {localidad.descripcion}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel>Calle</FormLabel>
            <Input
              name="calle"
              value={predio.calle}
              onChange={handleChange}
              placeholder="Calle"
              isRequired
            />
          </FormControl>
          <FormControl>
            <FormLabel>Número Exterior</FormLabel>
            <Input
              name="numeroExterior"
              value={predio.numeroExterior}
              onChange={handleChange}
              placeholder="Número Exterior"
              isRequired
            />
          </FormControl>
          <FormControl>
            <FormLabel>Colonia</FormLabel>
            <Input
              name="colonia"
              value={predio.colonia}
              onChange={handleChange}
              placeholder="Colonia"
              isRequired
            />
          </FormControl>
          <FormControl>
            <FormLabel>Población</FormLabel>
            <Input
              name="poblacion"
              value={predio.poblacion}
              onChange={handleChange}
              placeholder="Población"
              isRequired
            />
          </FormControl>
          <FormControl>
            <FormLabel>Localidad</FormLabel>
            <Select
              name="idLocalidad"
              value={predio.ClaveCatastral.idLocalidad}
              onChange={(e) =>
                handleSelectChange('idLocalidad', e.target.value)
              }
              placeholder="Seleccione una localidad"
              isRequired
            >
              {localidades.map((localidad) => (
                <option key={localidad.id} value={localidad.idLocalidad}>
                  {localidad.descripcion}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel>Paraje</FormLabel>
            <Input
              name="paraje"
              value={predio.paraje}
              onChange={handleChange}
              placeholder="Paraje"
              isRequired
            />
          </FormControl>
          <FormControl>
            <FormLabel>Código Postal</FormLabel>
            <Input
              name="codigoPostal"
              value={predio.codigoPostal}
              onChange={handleChange}
              placeholder="Código Postal"
              type="number"
              isRequired
            />
          </FormControl>
          <FormControl>
            <FormLabel>Niveles Construidos</FormLabel>
            <NumberInput
              value={predio.nivelesConstruidos}
              onChange={(valueString) =>
                handleNumberChange(
                  'nivelesConstruidos',
                  parseInt(valueString) || 0,
                )
              }
            >
              <NumberInputField name="nivelesConstruidos" />
            </NumberInput>
          </FormControl>
          <FormControl>
            <FormLabel>Indiviso</FormLabel>
            <NumberInput
              value={predio.indiviso}
              onChange={(valueString) =>
                handleNumberChange('indiviso', parseFloat(valueString))
              }
            >
              <NumberInputField name="indiviso" />
            </NumberInput>
          </FormControl>
          <FormControl
            gridColumn={{ base: 'span 1', md: 'span 2', lg: 'span 3' }}
          >
            <FormLabel>Domicilio De Notificacion</FormLabel>
            <Textarea
              name="DomicilioDeNotificacion"
              value={predio.DomicilioDeNotificacion || ''}
              onChange={handleChange}
              placeholder="Domicilio De Notificacion"
            />
          </FormControl>
          <FormControl
            gridColumn={{ base: 'span 1', md: 'span 2', lg: 'span 3' }}
          >
            <FormLabel>Observaciones</FormLabel>
            <Textarea
              name="observaciones"
              value={predio.observaciones || ''}
              onChange={handleChange}
              placeholder="Observaciones"
            />
          </FormControl>
        </SimpleGrid>
        <Button type="submit" bg="#5b182b" color="white" _hover={{ bg: "#691f30" }} mt={4} width="auto">
          {id ? 'Actualizar Predio' : 'Crear Predio'}
        </Button>
      </form>
    </Box>
  );
};

export default PredioForm;
